import { render, staticRenderFns } from "./PointRanking.vue?vue&type=template&id=dbe4a10a&scoped=true&"
import script from "./PointRanking.vue?vue&type=script&lang=js&"
export * from "./PointRanking.vue?vue&type=script&lang=js&"
import style0 from "./PointRanking.vue?vue&type=style&index=0&id=dbe4a10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe4a10a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
